import { Modal } from "@9amhealth/shared";
import styled from "@emotion/styled";

export const RefineModal = styled(Modal)`
  & > * {
    padding-bottom: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  min-height: 3rem;
  background: var(--toolbar-background, var(--dialog-background));
`;

export const Title = styled.h5`
  flex: 1 1 auto;
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
`;

export const HeaderSpacer = styled.div`
  flex: 0 0 auto;
  width: 2.5rem;
`;

export const CloseButton = styled.button`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border: 0;
  background: transparent;
  cursor: pointer;

  svg {
    width: 2rem;
    height: auto;
    color: var(--color-charcoal);
  }
`;

export const Body = styled.div`
  padding: 0.5rem 1rem 2rem;
`;

export const CorrectionInput = styled.textarea`
  display: block;
  width: 100%;
  min-height: 6rem;
  padding: 0.75rem;
  border: 1px solid rgba(33, 33, 33, 0.12);
  border-radius: 0.75rem;
  outline: none;
  resize: none;
  background: var(--color-white, #fff);
  font-family: inherit;
  font-size: 1rem;
  line-height: 1.45;
  letter-spacing: -0.02em;
  color: var(--color-charcoal, #212121);

  &:focus {
    border-color: rgba(33, 33, 33, 0.4);
  }

  &:disabled {
    opacity: 0.6;
  }

  &[data-invalid="true"] {
    border-color: var(--primary-warning-red, #bf1902);
  }
`;

export const FieldError = styled.span`
  display: block;
  padding: 0.5em 0 0;
  font-size: 0.875rem;
  color: var(--primary-warning-red, #bf1902);

  @keyframes show {
    from {
      opacity: 0;
      transform: translateY(-0.5rem);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  animation: show 0.2s linear forwards;
`;

export const ConfirmLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-top: 1.5rem;
`;
